import { FC, ReactNode } from 'react'

import { useQuery } from '@tanstack/react-query'
import { getRouteApi } from '@tanstack/react-router'
import { applicationPipelineReportQueryOptions } from '~bank-reports/service/applicationPipelineReportQueryOptions'
import { ApplicationPipelineReportResponse } from '~bank-reports/types/ApplicationPipelineReport'

import { ApplicationPipelineReportContext } from './ApplicationPipelineReportContext'

export const ApplicationPipelineReportContextProvider: FC<{
  children: ReactNode
}> = ({ children }) => {
  const routeApi = getRouteApi('/_app/reports/application-pipeline')
  const search = routeApi.useSearch()

  const { data, isFetching } = useQuery<ApplicationPipelineReportResponse>(
    applicationPipelineReportQueryOptions(search)
  )

  if (!data) return null

  return (
    <ApplicationPipelineReportContext.Provider value={{ data, isFetching, routeApi }}>
      {children}
    </ApplicationPipelineReportContext.Provider>
  )
}
